// src/services/authService.js
import axios from 'axios';

//const API_URL = 'https://localhost:7031/api'; // Replace with your API base URL
const API_URL = 'https://521xjb6dh4.execute-api.ap-southeast-1.amazonaws.com/dev/api';

export const login = async (email, password) => {
    try {
        const response = await axios.post(`${API_URL}/auth/login`, {
            email,
            password,
        });        
        return response.data;
    } catch (error) {
        console.error('Error logging in:', error.response ? error.response.data : error.message);
        throw error;
    }
};